import { render, staticRenderFns } from "./recordSecurity.vue?vue&type=template&id=2b5fbc26&scoped=true"
import script from "./recordSecurity.vue?vue&type=script&lang=js"
export * from "./recordSecurity.vue?vue&type=script&lang=js"
import style0 from "./recordSecurity.vue?vue&type=style&index=0&id=2b5fbc26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5fbc26",
  null
  
)

export default component.exports